export const MINIMUM_API_VERSION = 'v2025-02-19'
export const ASPECT_FILE_EXTENSIONS = ['.ts', '.js']
